import { Component } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'app-geofence-loading',
  imports: [SkeletonModule],
  templateUrl: './geofence-loading.html',
  styleUrls: ['./geofence-loading.scss', '../geofences-list/geofences-list.scss']
})
export class GeofenceLoading {}
